import {createFileRoute} from '@tanstack/react-router';

import QuickDiagnosticReportRequest from '@/practitioner/views/diagnosticReport/QuickDiagnosticReportRequest';

export const Route = createFileRoute(
  '/(practitioner)/practitioner/quick-diagnostic-report-request'
)({
  component: QuickDiagnosticReportRequest
});
